const getDirtyFieldsHelper = <Data extends object, Dirty extends object, Errors extends object>(
  data: Data,
  dirty: Dirty,
  errors: Errors,
): Partial<Data> =>
  (Object.keys(dirty) as Array<keyof Dirty>).reduce((acc, key) => {
    const value = data[key as unknown as keyof Data];
    const dirtyValue = dirty[key];
    const errorValue = errors?.[key as keyof Errors];

    const isValid = errorValue === undefined;

    if (!isValid) return acc;

    if (typeof dirtyValue === 'boolean') {
      if (dirtyValue) {
        return {
          ...acc,
          [key]: value,
        };
      }
      return acc;
    }

    if (typeof dirtyValue === 'object' && dirtyValue !== null && !Array.isArray(dirtyValue)) {
      if (typeof value === 'object' && value !== null) {
        const nestedDirtyFields = getDirtyFieldsHelper(value, dirtyValue, errorValue ?? {});
        if (Object.keys(nestedDirtyFields).length > 0) {
          return {
            ...acc,
            [key]: nestedDirtyFields,
          };
        }
        return acc;
      }
    }

    if (Array.isArray(dirtyValue) && Array.isArray(value) && dirtyValue.length === value.length) {
      const changes = dirtyValue.map((dirtyValueItem, index) => {
        const errorItem = (errorValue ?? [])[index];
        if (typeof dirtyValueItem === 'object' && dirtyValueItem !== null) {
          const nestedDirtyFields = getDirtyFieldsHelper(
            (value as any)[index],
            dirtyValueItem as object,
            errorItem ?? {},
          );
          return Object.keys(nestedDirtyFields).length > 0;
        }
        return dirtyValueItem && errorItem === undefined;
      }) as Array<boolean>;

      if (changes.some(Boolean)) {
        return {
          ...acc,
          [key]: value,
        };
      } else {
        return acc;
      }
    }

    return {
      ...acc,
      [key]: value,
    };
  }, {});

export default getDirtyFieldsHelper;
